const URL = require('url');

/**
 * List of query params to skip getting middleware if exist
 * @type {string[]}
 */
const listOfQueryParams = ['chkin', 'chkout', 'toDate', 'fromDate', 'daysInFuture', 'stayLength', 'startDate', 'endDate'].map(query =>
  query.toLowerCase()
);

/**
 * Returns a true/false to determine if path is HIS dated and should call seoMiddleware
 *
 * @param path Request path (e.g. /Sofitel-Chicago-Magnificent-Mile.h864219.Hotel-Information)
 * @param queryMap Request query map
 * @returns {boolean}
 */
const shouldGetSeoMiddleware = (path, queryMap) =>
  path.match(/[./]h\d.*\..*/g) &&
  Object.keys(queryMap)
    .map(key => key.toLowerCase())
    .filter(key => listOfQueryParams.includes(key)).length >= 1;

const getHotelIdFromPath = path => path.match(/[/.]h(\d+)[.]/g)[0].match(/\d+/g)[0];

const getPathnameFromUrl = url => {
  const { pathname } = URL.parse(url, true);

  return pathname;
};

/**
 * Returns a true/false to determine if we should be getting the specific flex view model for BEX US HIS.
 *
 * @param path Request path (e.g. /Sofitel-Chicago-Magnificent-Mile.h864219.Hotel-Information)
 * @param queryMap Request query map
 * @returns {boolean}
 */
const shouldSkipGettingFlexViewModel = (path, queryMap) =>
  !path.match(/[./]h\d.*\..*/g) ||
  !queryMap ||
  Object.keys(queryMap)
    .map(key => key.toLowerCase())
    .filter(key => listOfQueryParams.includes(key)).length > 0;

/**
 * Converts a key-value query map from an Express Request to a friendly query string
 * e.g. queryMap = { cache: false }
 * @param queryMap
 * @returns {string}
 */
const convertQueryMapToString = queryMap => {
  let queryParams = '';

  Object.keys(queryMap).forEach((key, index) => {
    queryParams = index === 0 ? `?${key}=${queryMap[key]}` : `${queryParams}&${key}=${queryMap[key]}`;
  });

  return queryParams;
};

/**
 * Gets all the cookies set in the response of Bernie's Platform Context Middleware
 * @param res Express Response
 * @returns A string of ';'-separated cookie key=value pairs
 */
const getCookiesFromContextResponse = res => {
  if (!res || !res._headers || !res._headers['set-cookie']) {
    return null;
  }

  const setCookies = res._headers['set-cookie'];

  // In case set-cookies is only one entry and is a string
  if (typeof setCookies === 'string') {
    return setCookies;
  }

  // linfo=v.4,|0|0|255|1|0||||||||3084|0|0||0|0|0|-1|-1; Domain=.wwwexpediaca.sandbox.dev.sb.karmalab.net; Expires=Sun, 08-Oct-2023 22:58:31 GMT; Path=/
  const cookies = setCookies.map(cookieAllInfo => cookieAllInfo.split(';')[0]);

  return cookies && cookies.join('; ');
};

/**
 * Converts a json to a Splunk friendly string.
 * e.g. { test: 123, cat: dog } becomes "test=123 cat=dog"
 * @param json
 * @returns {string}
 */
const jsonToSplunkFriendlyString = json =>
  Object.keys(json)
    .map(key => `${key}=${json[key]}`)
    .join(' ');

module.exports = {
  shouldSkipGettingFlexViewModel,
  convertQueryMapToString,
  jsonToSplunkFriendlyString,
  getCookiesFromContextResponse,
  shouldGetSeoMiddleware,
  getHotelIdFromPath,
  getPathnameFromUrl,
};
